<template >
  <div >
    <s-remote-select
        v-if="pups"
        v-model="routeString"
        xclass-model="pup"
        :options="pups"
       xquery-prop="q"
        :multiple="true"
        labelProp="loc_code"
        valueProp="loc_id"
        @change="$emit('input',routeString)"
        prefixField="name" ></s-remote-select >
  </div >
</template >

<script >
import commons from "~/mixins/commons";
export default {
  mixins: [commons],
  props: {
    value: {default: null}
  },
  name: "RouteBuilder",
  data() {
    return {routeString: this.value, pups: null}
  },
  async created() {
    this.pups = await this.getPups();
  },
  methods: {}
}
</script >

<style scoped >

</style >
